import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgLockedDoor: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 391.37 230.64" {...props}>
    <g style={{ isolation: 'isolate' }}>
      <path
        style={{ isolation: 'isolate' }}
        fill="#b8b8b8"
        d="M319.83 230.64l71.54-21.37h-111.5l-108.49 21.37h148.45z"
      />
      <path
        fill="#007fbf"
        d="M327.64 224.85l-7.81 5.79-124.51-13.01-23.94 3.72V5.79L179.19 0l106.26 123.15 42.19 101.7z"
      />
      <path fill="#007fbf" d="M179.19 0h148.44v224.85H179.19z" />
      <path fill="#049dff" d="M171.38 5.79h148.44v224.85H171.38z" />
      <path
        strokeMiterlimit={10}
        fill="#009dff"
        stroke="#007fbf"
        strokeWidth={2}
        d="M183.77 17.74h123.66v200.95H183.77z"
      />
      <path fill="#2d80d6" d="M196.19 115.51h25.5" />
      <path
        d="M221.69 121.45h-25.5a5.94 5.94 0 1 1 0-11.88h25.5a5.94 5.94 0 0 1 0 11.88z"
        fill="#999"
      />
      <path
        fill="#999"
        d="M225.22 120.28l-4.93 3.22-34-5.35 3-5.16 3.92-2.61 31.26 1.83.75 8.07z"
      />
      <path fill="#2d80d6" d="M192.23 118.15h25.5" />
      <path
        d="M217.73 124.09h-25.5a5.94 5.94 0 1 1 0-11.88h25.5a5.94 5.94 0 0 1 0 11.88z"
        fill="#e2e2e2"
      />
      <path
        d="M6.47 73.71L0 66.14l8.84-7 5.88 8 11.93 17.7L21 89.38zM25 99.25a6.77 6.77 0 0 1 1.49-9.15c3.25-2.39 7.56-1.38 9.8 2.11a6.83 6.83 0 0 1-1.51 9.07c-3.2 2.38-7.5 1.43-9.78-2.03z"
        fill="#ff3652"
      />
      <path
        d="M275.87 33.67a43.87 43.87 0 0 0-34.7 70.73c-3.06 5.21-9.29 12.06-9.29 12.06 8.39-1 13.61-2.77 16.85-4.45a43.87 43.87 0 1 0 27.14-78.34z"
        opacity={0.15}
      />
      <path
        d="M271.62 29.42a43.87 43.87 0 0 0-34.7 70.73c-3.06 5.21-9.29 12.06-9.29 12.06 8.38-1 13.61-2.77 16.84-4.45a43.88 43.88 0 1 0 27.15-78.34z"
        fill="#fff"
      />
      <path
        d="M260 67.61V57.52a12.21 12.21 0 0 1 24.41 0v10.09"
        stroke="#787878"
        strokeWidth={4}
        fill="none"
        strokeMiterlimit={10}
      />
      <rect
        x={246.91}
        y={62.99}
        width={50.59}
        height={33.43}
        rx={5.67}
        fill="#ffe600"
      />
      <rect
        x={246.91}
        y={62.99}
        width={50.59}
        height={33.43}
        rx={4.25}
        fill="#ffe539"
      />
      <circle cx={272.21} cy={75.88} r={4.83} fill="#787878" />
      <path
        fill="#787878"
        d="M274.14 77.44h-4.05l-.81 10.91h5.68l-.82-10.91z"
      />
      <path
        d="M165 89.78s56.53 13.22 48.6 35.05c0 0-4.37 7.27-10.77 1 0 0-6.41 7-11.23-.36 0 0-5.2 8.75-14.36 2.43 0 0-8.94-5.76-15-20.45.05-.05-1.24-15.79 2.76-17.67zM80.14 98.64s-53 23.81-41 43.7c0 0 5.68 6.31 10.75-1.12 0 0 7.64 5.68 11-2.51 0 0 6.78 7.59 14.57-.35 0 0 7.67-7.37 10.77-22.94-.08 0-1.85-15.69-6.09-16.78z"
        fill="#ff7300"
      />
      <path
        d="M178.11 62.05l-10.56-23.16a4.18 4.18 0 0 0-6-1.84L151.84 43a2.77 2.77 0 0 1-2.41.21 74.43 74.43 0 0 0-68.93 8.63 3.53 3.53 0 0 1-3 .52l-10.28-3a4.19 4.19 0 0 0-5.31 3.3l-3.98 22.9a23.16 23.16 0 0 1-1.71 5.51 69.78 69.78 0 0 0-5.84 36.67c4.36 39.12 40.32 67.26 80.33 62.76s68.92-39.77 64.55-78.89a69.64 69.64 0 0 0-15.06-36.13 15.82 15.82 0 0 1-2.09-3.43z"
        fill="#ff7300"
      />
      <path
        d="M122.82 229.45c22.66 0 41-1.36 41-4.73s-18.36-5.95-41-5.95-41 3.12-41 6.49 18.34 4.19 41 4.19z"
        style={{ isolation: 'isolate' }}
        fill="#b8b8b8"
      />
      <path
        d="M85.59 159c-7.89-7.36-4.71-17.6.67-19.43 10-3.39 16.41 6.59 16.41 6.59s-5.17-14 10.17-16c7-.91 16.56 1.69 16.81 13.16 0 0 2.6-12 13.25-11.15 12.59 1 13.42 14.62 11 20.68s-11.36 12.25-31.2 13.8c-21.16 1.6-29.21-.32-37.11-7.65z"
        opacity={0.1}
      />
      <path
        d="M83.61 161c-7.9-7.37-4.72-17.61.66-19.43 10-3.4 16.42 6.59 16.42 6.59s-5.18-14 10.17-16c7-.91 16.55 1.7 16.81 13.16 0 0 2.59-12 13.25-11.15 12.58 1 13.41 14.62 11 20.68s-11.36 12.25-31.2 13.8c-21.17 1.59-29.21-.34-37.11-7.65z"
        fill="#ff7300"
      />
      <path
        d="M83.61 161c-7.9-7.37-4.72-17.61.66-19.43 10-3.4 16.42 6.59 16.42 6.59s-5.18-14 10.17-16c7-.91 16.55 1.7 16.81 13.16 0 0 2.59-12 13.25-11.15 12.58 1 13.41 14.62 11 20.68"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.05}
        fill="none"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgLockedDoor;
